const MoreInfo = ({ lessonData }) => {
  return (
    <>
      <div
        className="modal fade"
        id="more-info"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header new-driver-modal-heading">
              <h5 className="modal-title" id="staticBackdropLabel">
                {lessonData && lessonData.popup_header
                  ? lessonData.popup_header
                  : ""}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body more-info-content">
              {/* <h4 className="mb-md-2 mb-md-3">Course Description</h4> */}
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    lessonData && lessonData.long_description
                      ? lessonData.long_description
                      : "",
                }}
              />
              <div className="detail-btn d-flex align-items-center flex-wrap-reverse flex-sm-nowrap justify-content-center justify-content-sm-start full-width-btn">
                {lessonData && lessonData.register_url && (
                  <a
                    href={lessonData.register_url} target="_blank" rel="noopener noreferrer"
                    className="btn yellow-btn me-sm-4 me-md-3 "
                  >
                    Register
                    <i className="fa-solid fa-circle-chevron-right"></i>
                  </a>
                )}
                {lessonData &&
                  lessonData.popup_header !== "Florida Permit Test Online" && (
                    <div className="price mb-3 mb-sm-0">
                      $ {lessonData.price}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MoreInfo;
